import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { ApClassFormatDTOBase } from "./ApClassFormatDTOBase";
import type { ApClassStaff } from "./ApClassStaff";
import type { ApClassTypeStaff } from "./ApClassTypeStaff";
import type { TrackedBase } from "./TrackedBase";

export class ApClassFormatStaff implements ApClassFormatDTOBase, TrackedBase {
  constructor(public readonly formatId: number, public readonly description: string | null, public readonly priceDefaultOverride: number | null, public readonly sessionCtDefault: number, public readonly sessionLengthDefault: number, public readonly signupMaxDefaultOverride: number | null, public readonly signupMinDefaultOverride: number | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly typeId: ApClassTypeStaff | null, public readonly instances: Array<ApClassStaff> | null) {
    this.cbiServiceContext = null;
    this.typeIdLoaded = this.typeId != null;
    this.typeIdCached = this.typeId;
    this.instancesLoaded = this.instances != null;
    this.instancesCached = this.instances;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private typeIdLoaded: boolean;
  private typeIdCached: ApClassTypeStaff | null;
  private instancesLoaded: boolean;
  private instancesCached: Array<ApClassStaff> | null;
  async typeIdLazy(): Promise<ApClassTypeStaff> {
    if (!this.typeIdLoaded) {
      this.typeIdCached = await this.cbiServiceContext!.apClassService().getApClassFormatStaffTypeId(this.formatId);
      this.typeIdLoaded = true;
    }
    return this.typeIdCached!;
  }
  async instancesLazy(): Promise<Array<ApClassStaff>> {
    if (!this.instancesLoaded) {
      this.instancesCached = await this.cbiServiceContext!.apClassService().getApClassFormatStaffInstances(this.formatId);
      this.instancesLoaded = true;
    }
    return this.instancesCached!;
  }
}
